export const FETCH_BOTTOM_NAVIGATION_REQUEST = 'BOTTOM_NAVIGATION/FETCH_BOTTOM_NAVIGATION_REQUEST';
export const FETCH_BOTTOM_NAVIGATION_FAILURE = 'BOTTOM_NAVIGATION/FETCH_BOTTOM_NAVIGATION_FAILURE';
export const FETCH_BOTTOM_NAVIGATION_SUCCESS = 'BOTTOM_NAVIGATION/FETCH_BOTTOM_NAVIGATION_SUCCESS';
